const API_URL = `${import.meta.env.VITE_API_URL}/api`;

function request(method: string) {
  return (url: string, body?: any): Promise<Response> => {
    const fullUrl = [API_URL, url].join("/");

    const options: RequestInit = {
      method,
      headers: {},
    };
    if (body) {
      options.headers = {
        ...options.headers,
        "Content-Type": "application/json",
      };
      options.body = JSON.stringify(body);
    }

    return fetch(fullUrl, options);
  };
}

const api = {
  get: request("GET"),
  post: request("POST"),
  put: request("PUT"),
  patch: request("PATCH"),
  delete: request("DELETE"),
};

export default api;
